import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import promise from 'redux-promise';
import thunk from 'redux-thunk'
import {createMiddleware} from 'redux-api-middleware';
import {reducer as formReducer} from 'redux-form';
import {createErrorReporterMiddleware} from '@common/helpers/installGlobalErrorReporter';
import authRedirectMiddleware from '../middleware/authRedirectMiddleware';
import PreloaderReducer from './PreloaderReducer';
import QueryReducer from './QueryReducer';

const composeEnhancers =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;

const coreMiddleware = [
    promise,
    createMiddleware(),
    thunk,
    // 401 handler must sit AFTER `createMiddleware` so it sees the
    // FAILURE action the api-middleware emits, and BEFORE the error
    // reporter so a guest-401 doesn't pollute the error log as a
    // genuine bug. Triggers a single `/customer/?returnUrl=…` hop on
    // any 401, regardless of which bundle dispatched the action.
    authRedirectMiddleware(),
    createErrorReporterMiddleware(),
];

const coreReducers = {
    preloader: PreloaderReducer,
    form: formReducer,
    query: QueryReducer,
};

export default function configureStore(reducers, initialState, middleware = []) {
    const rootReducer = combineReducers({
        ...coreReducers,
        ...reducers,
    });

    const enhancer = composeEnhancers(
        applyMiddleware(...coreMiddleware.concat(middleware)),
    );

    return createStore(rootReducer, initialState, enhancer);
};